/**
 * Single source of truth for the CDN that hosts PikPok's sample content.
 *
 * Currently a public Cloudflare R2 bucket (managed `*.r2.dev` domain).
 * Two prefixes live under it:
 *   - /unsplash/<photo-id>.webp  — the 50 Unsplash photos used by the app,
 *     downloaded once at w=1200 q=70 webp and uploaded so the app has no
 *     external HTTP dependency.
 *   - /images/<filename>          — user-supplied sample images from
 *     ~/Downloads/app-sample-content/images (mirrored to R2).
 *   - /reels/<filename>           — user-supplied sample MP4s from
 *     ~/Downloads/app-sample-content/reels (mirrored to R2).
 *
 * When this gets swapped for a custom domain or the native APK starts
 * shipping these assets locally, change this one constant.
 */
export const CDN = "https://pub-7e254a577047429dafce9f66a5ecda79.r2.dev";

/** Build a URL for one of the 50 mirrored Unsplash photos. */
export const r2Image = (id: string) => `${CDN}/unsplash/${id}.webp`;

/** Build a URL for a file under the sample-content tree (e.g. "reels/reel-1.mp4"). */
export const r2Sample = (path: string) => `${CDN}/${path}`;
